module.exports = __webpack_public_path__ + "img/flag-PT.b3609e6f.svg";